import { Column, Columns, Container } from '@codeparva/ui-components-library';
import React from 'react';
import { LocationTitle } from './config';
import { SelectLocationsTypes } from './SelectLocationsTypes';
import { weakKey } from '../../../../utilities/weakKey';
import { SelectLocationCards } from './helper/SelectLocationCards';

export const SelectLocations = ({
  allAvailableLocations,
  dataFrom,
  componentClicked,
}: SelectLocationsTypes.ILocationsTypes) => {
  return (
    <div className="selectLocationContainer">
      <Container className="locationTilesContainer">
        <Columns className="locationTitleColumns">
          <Column className="locationTitleColumn">
            <div className="locationTitleDiv">
              <h5 className="has-text-black locationTitle">{LocationTitle}</h5>
            </div>
          </Column>
        </Columns>
        {allAvailableLocations.map((location, index) => {
          return (
            <Columns
              vCentered
              className="locationCardsColumns"
              key={weakKey(location)}
              data-cy={`select-location-${index}`}
            >
              <SelectLocationCards
                location={location}
                dataFrom={dataFrom}
                componentClicked={componentClicked}
              />
            </Columns>
          );
        })}
      </Container>
    </div>
  );
};
